import { render } from "./DeliveryInformationForm.vue?vue&type=template&id=57448896"
import script from "./DeliveryInformationForm.vue?vue&type=script&lang=js"
export * from "./DeliveryInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__